import api, { clearInstance } from "../_helpers/mainapi";
import { websiteConstants } from "../_constants/website.constants";
import { notification } from "./notifications.actions";
import _ from "lodash";

export const getWebSitePages =
  (page = 1, pageSize = 10, orderBy = "asc") =>
    async (dispatch, getState) => {
      let params = {
        Page: page,
        PageSize: pageSize,
        OrderBy: orderBy,
      };

      let response = await api.get(`/cms/getallpages`, {
        params,
      });

      dispatch({
        type: websiteConstants.FETCH_WEBSITE_PAGES,
        payload: response.data,
      });
    };

export const getWebPageById = async (id) => {
  let response = await api.get(`/cms/getWebPageById`, { params: { id } });

  return response.data;
};

export const getWebPageBySeoUrl = async (seoUrl) => {
  let response = await api.get(`/cms/getWebPageBySeoUrl`, {
    params: { seoUrl },
  });

  return response.data;
};

export const getNotFoundPage = async () => {
  let response = await api.get(`/cms/getNotFoundPage`);

  return response.data;
};

export const saveWebSitePage = async (
  id,
  title,
  content,
  widgetTitle,
  widgetText,
  widgetExternalLink,
  widgetLogo
) => {
  const formData = new FormData();

  if (id) formData.append("Id", id);
  formData.append("title", title);
  formData.append("content", content);
  formData.append("widgetTitle", widgetTitle);
  formData.append("widgetText", widgetText);
  formData.append("widgetExternalLink", widgetExternalLink);
  formData.append("widgetLogo", widgetLogo);

  const response = await clearInstance.post(`/cms/saveWebPage`, formData);

  return response.data;
};

export const checkPageTitleExist = async (id, title) => {
  const response = await api.get(`/cms/checkPageTitleExist`, { params: { id, title }});
  return response.data;
}
export const checkTrPageTitleExist = async (id, title, langSymbol) => {
  const response = await api.get(`/cms/checkTrPageTitleExist`, { params: { id, title, langSymbol }});
  return response.data;
}

export const saveNotFoundPage = async (
  title,
  content
) => {
  const formData = new FormData();


  formData.append("title", title);
  formData.append("content", content);;

  const response = await api.post(`/cms/saveNotFoundPage`, formData);

  return response.data;
};


export const deleteWebPage = (id) => async (dispatch, getState) => {
  const response = await api.post(`/cms/deleteWebPage`, {
    id,
  });

  if (response.data) {
    dispatch({
      type: websiteConstants.DELETE_WEBSITE_PAGE,
      payload: id,
    });

    notification.success({
      title: "Success",
      message: "Page deleted",
    });
  } else {
    notification.error({
      title: "Error",
      message: "Page not deleted, try again",
    });
  }
};

export const pageSizeChange = (pageSize) => {
  return {
    type: websiteConstants.SEARCH_PAGE_SIZE,
    payload: pageSize,
  };
};

export const pageChange = (page) => {
  return {
    type: websiteConstants.SEARCH_ACTIVE_PAGE,
    payload: page,
  };
};

export const getMenu = () => async (dispatch, getState) => {
  let response = await api.get(`/cms/getMenu`);

  dispatch({
    type: websiteConstants.FETCH_MENU_ITEMS,
    payload: response.data.menu,
  });

  return response.data.pages;
};

export const saveMenuItem =
  (id, title, cmsPageId, translationPages) => async (dispatch, getState) => {
    if (!title) {
      notification.error({
        title: "Error",
        message: "Menu Item title is mandatory",
      });

      return;
    }

    const formData = new FormData();

    if (id) formData.append("Id", id);
    formData.append("title", title);
    if (cmsPageId) formData.append("cmsPageId", cmsPageId);

    if (translationPages && translationPages.length > 0) {
      for (var i = 0; i < translationPages.length; i++) {
        formData.append("translationPages[" + i + "].title", translationPages[i].title);
        formData.append("translationPages[" + i + "].order", translationPages[i].order);
        formData.append("translationPages[" + i + "].langSymbol", translationPages[i].langSymbol);
      }
    }

    try {
      const response = await api.post(`/cms/saveMenuItem`, formData);

      dispatch({
        type: websiteConstants.ADD_OR_EDIT_MENU_ITEM,
        payload: response.data,
      });
    } catch (err) {
      notification.error({
        title: "Error",
        message: "Menu Item not saved, try again",
      });
    }
  };

export const deleteMenuItem = (menuItem) => async (dispatch, getState) => {
  const { id, order } = menuItem;

  const response = await api.post(`/cms/deleteMenuItem`, { id });

  if (response.data) {
    dispatch({
      type: websiteConstants.DELETE_MENU_ITEM,
      payload: { id, order },
    });

    notification.success({
      title: "Success",
      message: "Menu Item deleted",
    });
  } else {
    notification.error({
      title: "Error",
      message: "Menu Item not deleted, try again",
    });
  }
};

export const reorderMenuItem =
  (id, direction) => async (dispatch, getState) => {
    const formData = new FormData();

    formData.append("id", id);
    formData.append("direction", direction);

    let response = await api.post(`/cms/reorderMenuItem`, formData);

    dispatch({
      type: websiteConstants.REORDER_MENU_ITEM,
      payload: response.data,
    });
  };

export const getFooterLayouts = () => async (dispatch, getState) => {
  let response = await api.get(`/cms/getFooterLayouts`);

  dispatch({
    type: websiteConstants.FETCH_FOOTER_LAYOUTS,
    payload: response.data,
  });

  return response.data;
};

export const modifyFooterLayoutColumnText =
  (layoutId, position, text, columnType) => async (dispatch, getState) => {
    dispatch({
      type: websiteConstants.MODIFY_FOOTER_LAYOUT_COLUMN_TEXT,
      payload: {
        layoutId,
        position,
        text,
        type: columnType,
      },
    });
  };

export const modifyFooterLayoutColumnLogo =
  (layoutId, position, logo, logoPreview, columnType) =>
    async (dispatch, getState) => {
      var action = {
        type: websiteConstants.MODIFY_FOOTER_LAYOUT_COLUMN_LOGO,
        payload: {
          layoutId,
          position,
          footerLogoId: null,
          type: columnType,
          logoPreview,
        },
      };

      if (logo) {
        const formData = new FormData();
        formData.append("file", logo);

        let response = await clearInstance.post(`/cms/uploadCmsFile`, formData);
        let footerLogoId = response.data;

        action.payload = { ...action.payload, footerLogoId };
      }

      dispatch(action);
    };

export const modifyFooterLayoutColumnLogoLink =
  (layoutId, position, link, columnType) => async (dispatch, getState) => {
    dispatch({
      type: websiteConstants.MODIFY_FOOTER_LAYOUT_COLUMN_LINK,
      payload: {
        layoutId,
        position,
        link,
        type: columnType,
      },
    });
  };

export const saveFooterLayoutColumns =
  (layoutId) => async (dispatch, getState) => {
    var changes = getState().website.modifiedFooterColumns;
    var links = getState().website.modifiedFooterColumnsLinks;
    const footerColumns = _.filter(changes, (x) => x.layoutId === layoutId);
    const footerColumnsLinks = _.filter(links, (x) => x.layoutId === layoutId);

    if (footerColumns) {
      //const response =
      const response = await api.post(`/cms/saveCmsFooterLayout`, {
        layoutId,
        footerColumns,
        footerColumnsLinks,
      });
      return response;
    }
  };

export const saveFooterTranslationModifiedColumns =
  (layoutId, langSymbol) => async (dispatch, getState) => {
    var changes = getState().website.modifiedFooterColumns;
    const translationPages = _.filter(changes, (x) => x.layoutId === layoutId);

    const response = await api.post(`/cms/saveFooterTranslationModifiedColumns`, {
      layoutId,
      langSymbol,
      translationPages
    });
    return response;

  };

export const saveFooterTranslation =
  (translationPage) => async (dispatch, getState) => {
    var translationPages = [];
    translationPages.push(translationPage);
    const response = await api.post(`/cms/saveFooterTranslation`, { translationPages });
    return response;
  };


export const getActiveFooter = () => async (dispatch) => {
  let response = await api.get(`/cms/getFooter`);

  dispatch({
    type: websiteConstants.FETCH_ACTIVE_FOOTER,
    payload: response.data,
  });
};

export const getFooterTranslationColumns = async (langSymbol) => {
  let response = await api.get(`/cms/getFooterTranslationColumns`, { params: { langSymbol } });
  return response.data;
};


export const saveNotfoundLayoutTranslation = (translation) => async (dispatch, getState) => {
  const response = await api.post(`/cms/savenotfoundlayouttranslation`, translation);
  return response.data;
};

export const saveTranslation = (translation) => async (dispatch, getState) => {
  const formData = new FormData();

  if (translation.id) formData.append("id", translation.id);
  formData.append("title", translation.title);
  formData.append("content", translation.content);
  formData.append("widgetTitle", translation.widgetTitle);
  formData.append("widgetText", translation.widgetText);
  formData.append("widgetExternalLink", translation.widgetExternalLink);
  formData.append("widgetLogo", translation.widgetLogo);
  formData.append("widgetLogoPreview", translation.widgetLogoPreview);
  formData.append("url", translation.url);
  formData.append("cmsPageId", translation.cmsPageId);
  formData.append("langSymbol", translation.langSymbol);

  const response = await clearInstance.post(`/cms/savetranslation`, formData);
  return response.data;
};